import BioItems from "../bio_items";
import { useGet } from "../hooks";
import Navbar from "../navbar";
import Footer from "../footer";

function About() {
  const contactURL =
    "https://stetor16.dreamhosters.com/wp-json/acf/v3/contact_info";

  const [data, loading] = useGet(contactURL);

  return (
    <>
      <Navbar />
      <div className="about__page-container pb-5">
        <BioItems />
        {loading ? (
          "Loading..."
        ) : (
          <>
            {data.map((d) => {
              return (
                <div
                  className="contact__info-container text-center "
                  key={d.id}
                >
                  <h1 className="contact__info-title site__heading">
                    Contact info:
                  </h1>

                  <p className="contact__info site__paragraph">
                    {d.acf.contact_info}
                  </p>

                  {d.acf.linkedin && (
                    <a
                      target="_blank"
                      href={d.acf.linkedin.url}
                      className="btn btn--white btn--animated m-3"
                    >
                      {d.acf.linkedin.title}
                    </a>
                  )}

                  {d.acf.medium_link && (
                    <a
                      target="_blank"
                      href={d.acf.medium_link.url}
                      className="btn btn--white btn--animated m-3"
                    >
                      {d.acf.medium_link.title}
                    </a>
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
      <Footer />
    </>
  );
}
export default About;
